module.exports = __webpack_public_path__ + "6ef960861d8dbc7e8a6b8c157ab7433b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/contract-signature/back.png
// module id = 1302
// module chunks = 61